import type { Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    revamp?: boolean;
  }

  interface ThemeOptions {
    revamp?: boolean;
  }
}

/** Theme contrast and product ownership are separate concerns. */
export const isRevampDashboardTheme = (theme: Theme): boolean =>
  theme.revamp === true;
